const matchesType = (actionCreator: any) => (action: any) => actionCreator().type === action.type;

export {
  matchesType,
};
